module.exports = __webpack_public_path__ + "img/tram-orange.59d07d84.svg";